import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { NeoIntermediarioFinancieroService } from '../../Service/neoIntermediarioFinanciero.service';
import { AlertService } from '../../../services/alert.service';
import { RouterService } from '../../../services/router.service';
import { UserService } from '../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
declare var $: any;

const datosDetalleSolicitud = {
  idSolicitud: '',
  idCliente: null,
  idUsuario: null,
};

const datosNegarSolicitudAprobador = {
  idCliente: null,
  idSolicitud: '',
  id_tipo_negacion: null,
  idUsuario: null,
  observaciones:''
};
@Component({
    selector: 'app-confirmar-negacion-if',
    templateUrl: './confirmar-negacion-if.component.html',
    styleUrls: ['./confirmar-negacion-if.component.scss'],
    providers: [NeoIntermediarioFinancieroService],
    standalone: false
})
export class ConfirmarNegacionIfComponent implements OnInit {
  public detalleSolcitud: any;
  public user;

  constructor(
    public router: Router,
    private _route: ActivatedRoute,
    private _userIntermediarioService: UserService,
    private _neoIntermediarioFinancieroService: NeoIntermediarioFinancieroService,
    private alertService: AlertService,
    private _router: RouterService,
    private _sweetAlert:SweetAlertService
  ) {
    this.user = this._userIntermediarioService.getUser();
  }

  ngOnInit(): void {
    this._route.params.subscribe((params: Params) => {
      datosDetalleSolicitud.idSolicitud = params['id'];
      datosDetalleSolicitud.idCliente = Number(this.user.idCliente);
      datosDetalleSolicitud.idUsuario = Number(this.user.idUsuario);
    });

    this._neoIntermediarioFinancieroService
      .detalleAprobador(datosDetalleSolicitud)
      .subscribe(
        (response) => {
          if (response['exitoso']) {
            this.detalleSolcitud = response['data'];
          } else {
            this._sweetAlert.errorModal("Error!",true,
              'No fue posible cargar el detalle de la solicitud'
            );
          }
        },
        (error) => {
          this._sweetAlert.errorModal("Error!",true,
            'No fue posible cargar el detalle de la solicitud'
          );
          this.router.navigate(['intermediario/transaccional/aprobarSolicitudes']);
        }
      );

    datosNegarSolicitudAprobador.idCliente = Number(this.user.idCliente);
    datosNegarSolicitudAprobador.idSolicitud =
      datosDetalleSolicitud.idSolicitud;
    datosNegarSolicitudAprobador.idUsuario = Number(this.user.idUsuario);
  }

  cancelar() {
    this._router.goBack();
  }

  confirmarNegacion() {
    datosNegarSolicitudAprobador.id_tipo_negacion = Number(
      this.detalleSolcitud.negacion.idTipoNegacion
    );
    datosNegarSolicitudAprobador.observaciones = this.detalleSolcitud.observacionesNegacion;
    this._neoIntermediarioFinancieroService
      .negarSolicitudAprobador(datosNegarSolicitudAprobador)
      .subscribe(
        (response) => {
          if (response['exitoso'] == true) {
            this._sweetAlert.successModal('¡Éxito!',
            false,
            'La confirmación de la negación ha sido realizada correctamente').then(
              (result)=>{
                if(result.isConfirmed){
                  this.router.navigate(['/intermediario/home']);
                }
              });
              // $('#aceptarModal').modal('show');
          } else {
            this._sweetAlert.errorModal("Error!",true,
              'No fue posible aprobar la negación de la solicitud'
            );
          }
        },
        (error) => {
          this._sweetAlert.errorModal("Error!",true,
            'No fue posible aprobar la negación de la solicitud'
          );
        }
      );
  }

  aceptar() {
    $('#aceptarModal').modal('hide');
    this.router.navigate(['/intermediario/home']);
  }
}
